export default __webpack_public_path__ + "static/media/RoundCheck.6a257c40.svg";